import React from 'react';

import { PageSizeInput } from '@components/NextForms/PageSizeInput';
import { useSearch } from '@hooks/next/useSearch';
import { PaginationType } from '@models/next/PaginationType';
import { useForm } from '@monoid-dev/mobx-zod-form-react';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { DEFAULT_PAGE_SIZE } from '@utils/types';

const useStyles = makeMuiStyles((theme, common) => ({
  pageSizeForm: {
    ...common.flexInline,
    ...common.justifyEnd,
    ...common.middleText,
  },
}));

export interface PageSizeFormProps {}

export const PageSizeForm: React.FC<PageSizeFormProps> = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const { search, updateSearch } = useSearch(PaginationType);

  const form = useForm(PaginationType, {
    initialOutput: {
      page: search.page ?? 1,
      page_size: search.page_size ?? DEFAULT_PAGE_SIZE,
    },
  });

  return (
    <form
      {...form.bindForm({
        onSubmit(values) {
          updateSearch(values);
        },
      })}
      className={classes.pageSizeForm}
    >
      <PageSizeInput field={form.root.fields.page_size} />
    </form>
  );
};
